import { ALERT_ID_SEARCH_REGEX } from '@kentik/ui-shared/alerting/constants';

/** A filter field `beforeOnChange` that rejects characters an alert id search can't contain (returning true rejects). */
export const rejectInvalidAlertIds = (
  _field: unknown,
  _fieldValue: unknown,
  _previousValue: unknown,
  _form: unknown,
  newValue?: string
): boolean => !ALERT_ID_SEARCH_REGEX.test(newValue || '');
